import { render, staticRenderFns } from "./BsiContinuousFilingAttachments.vue?vue&type=template&id=6731fbd4&scoped=true&"
import script from "./BsiContinuousFilingAttachments.vue?vue&type=script&lang=js&"
export * from "./BsiContinuousFilingAttachments.vue?vue&type=script&lang=js&"
import style0 from "./BsiContinuousFilingAttachments.vue?vue&type=style&index=0&id=6731fbd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6731fbd4",
  null
  
)

export default component.exports